var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/FieldHelpIcon.tsx
import avMessages from "@availity/message-core";
import { HelpCircleIcon } from "@availity/mui-icon";
import { IconButton } from "@availity/mui-button";
import { jsx } from "react/jsx-runtime";
var triggerFieldHelp = (id) => {
  avMessages.send({
    event: "nav:help:field",
    id
  });
};
var FieldHelpIcon = (_a) => {
  var _b = _a, { helpTopicId, labelId, sx } = _b, rest = __objRest(_b, ["helpTopicId", "labelId", "sx"]);
  return /* @__PURE__ */ jsx(
    IconButton,
    __spreadProps(__spreadValues({}, rest), {
      color: "primary",
      title: "Help",
      role: "link",
      onClick: () => triggerFieldHelp(helpTopicId),
      "aria-describedby": labelId,
      size: "small",
      sx: __spreadProps(__spreadValues({}, sx), { fontSize: "inherit", marginTop: "-2px", opacity: 1 }),
      children: /* @__PURE__ */ jsx(HelpCircleIcon, { "aria-hidden": true, titleAccess: void 0 })
    })
  );
};

// src/lib/FormControl.tsx
import { default as FormControl } from "@mui/material/FormControl";

// src/lib/FormControlLabel.tsx
import { forwardRef } from "react";
import Box from "@mui/material/Box";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box, {
  name: "MuiFormControlLabel",
  slot: "AvWrapper",
  overridesResolver: (props, styles) => styles.avWrapper
})({});
var FormControlLabel = forwardRef((_a, ref) => {
  var _b = _a, { helpTopicId, id, sx } = _b, rest = __objRest(_b, ["helpTopicId", "id", "sx"]);
  const labelId = id || (rest.htmlFor ? `${rest.htmlFor}-label` : void 0);
  return /* @__PURE__ */ jsxs(Wrapper, { className: "MuiFormControlLabel-avWrapper", sx, ref, children: [
    /* @__PURE__ */ jsx2(MuiFormControlLabel, __spreadValues({ id: labelId }, rest)),
    helpTopicId ? /* @__PURE__ */ jsx2(FieldHelpIcon, { helpTopicId: "12345", labelId }) : null
  ] });
});

// src/lib/FormGroup.tsx
import { default as FormGroup } from "@mui/material/FormGroup";

// src/lib/FormHelperText.tsx
import MuiFormHelperText from "@mui/material/FormHelperText";
import { WarningTriangleIcon } from "@availity/mui-icon";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var FormHelperText = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsxs2(MuiFormHelperText, __spreadProps(__spreadValues({}, props), { children: [
    /* @__PURE__ */ jsx3(WarningTriangleIcon, { sx: { marginRight: "4px" }, titleAccess: "Error", "aria-hidden": false }),
    children
  ] }));
};

// src/lib/FormLabel.tsx
import { forwardRef as forwardRef2 } from "react";
import { default as MuiFormLabel } from "@mui/material/FormLabel";
import { styled as styled2 } from "@mui/material/styles";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Wrapper2 = styled2("div", {
  name: "MuiFormLabel",
  slot: "AvWrapper",
  overridesResolver: (props, styles) => styles.avWrapper
})({});
var StyleOverrides = {
  position: "relative !important",
  transform: "none !important",
  transition: "none !important",
  animation: "none !important"
};
var FormLabel = forwardRef2((props, ref) => {
  const _a = props, { helpTopicId, id, sx } = _a, rest = __objRest(_a, ["helpTopicId", "id", "sx"]);
  const labelId = id || (rest.htmlFor ? `${rest.htmlFor}-label` : void 0);
  return /* @__PURE__ */ jsxs3(Wrapper2, { className: "MuiFormLabel-avWrapper", sx, children: [
    /* @__PURE__ */ jsx4(MuiFormLabel, __spreadProps(__spreadValues({ id: labelId, sx: __spreadValues({}, StyleOverrides) }, rest), { ref })),
    helpTopicId ? /* @__PURE__ */ jsx4(FieldHelpIcon, { helpTopicId, labelId, sx: { px: 0.5 } }) : null
  ] });
});

// src/lib/Input.tsx
import { forwardRef as forwardRef3 } from "react";
import MuiInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import { jsx as jsx5 } from "react/jsx-runtime";
var InputPropOverrides = {
  notched: false
};
var Input = forwardRef3((props, ref) => {
  const _a = props, { required, inputProps } = _a, rest = __objRest(_a, ["required", "inputProps"]);
  return /* @__PURE__ */ jsx5(
    MuiInput,
    __spreadProps(__spreadValues(__spreadValues({}, rest), InputPropOverrides), {
      ref,
      inputProps: __spreadValues({ "aria-required": required || void 0 }, inputProps)
    })
  );
});

// src/lib/Radio.tsx
import { default as MuiRadio } from "@mui/material/Radio";
import { jsx as jsx6 } from "react/jsx-runtime";
var Radio = (args) => {
  return /* @__PURE__ */ jsx6(MuiRadio, __spreadProps(__spreadValues({}, args), { size: "small" }));
};

// src/lib/RadioGroup.tsx
import { forwardRef as forwardRef4 } from "react";
import MuiRadioGroup from "@mui/material/RadioGroup";
import { jsx as jsx7 } from "react/jsx-runtime";
var RadioGroup = forwardRef4((_a, ref) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx7(MuiRadioGroup, __spreadProps(__spreadValues({}, rest), { ref, children }));
});

// ../typography/src/lib/Typography.tsx
import { forwardRef as forwardRef5 } from "react";
import { default as MuiTypography } from "@mui/material/Typography";
import { jsx as jsx8 } from "react/jsx-runtime";
var Typography = forwardRef5(
  (_a, ref) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx8(MuiTypography, __spreadProps(__spreadValues({}, rest), { ref, children }));
  }
);

// src/lib/RequiredKey.tsx
import { styled as styled3 } from "@mui/material/styles";
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
var RequiredKey = () => {
  const Asterisk = styled3(Typography, {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles) => styles.asterisk
  })({ marginLeft: "0!important", marginRight: "0!important" });
  return /* @__PURE__ */ jsxs4(Typography, { children: [
    /* @__PURE__ */ jsx9(Asterisk, { component: "span", children: "*" }),
    " is a required field."
  ] });
};

// src/lib/SearchBy.tsx
import { Stack } from "@availity/mui-layout";
import { styled as styled4 } from "@mui/material/styles";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var SearchByContainer = styled4(FormGroup, {
  name: "AvSearchBy",
  slot: "root",
  overridesResolver: (props, styles) => styles.root
})(() => ({
  // TODO v7: check if Autocomplete fullWidth bug is fixed https://github.com/mui/material-ui/issues/36841
  ".MuiAutocomplete-root, .MuiAutocomplete-fullWidth": {
    width: "auto"
  },
  ".MuiFormControl-fullWidth": {
    flex: 1
  },
  "> .MuiStack-root": {
    display: "flex",
    flexWrap: "wrap",
    "> .MuiFormControl-root": {
      minWidth: "10rem"
    }
  },
  "& :is(.MuiFormControl-root, .MuiAutocomplete-root):not(:is(.MuiFormControl-root, .MuiAutocomplete-root):first-of-type)": {
    ".MuiInputBase-root": {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0
    }
  },
  "& :is(.MuiFormControl-root, .MuiAutocomplete-root):not(:is(.MuiFormControl-root, .MuiAutocomplete-root):last-of-type)": {
    ".MuiInputBase-root": {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      marginRight: "-1px"
    }
  }
}));
var SearchByFormGroup = (_a) => {
  var _b = _a, { children, searchById, searchByLabel = "Search By" } = _b, rest = __objRest(_b, ["children", "searchById", "searchByLabel"]);
  return /* @__PURE__ */ jsxs5(SearchByContainer, __spreadProps(__spreadValues({}, rest), { children: [
    /* @__PURE__ */ jsx10(FormLabel, { htmlFor: searchById, children: searchByLabel }),
    /* @__PURE__ */ jsx10(Stack, { direction: "row", children })
  ] }));
};

// src/lib/Select.tsx
import { useState } from "react";
import MuiSelect from "@mui/material/Select";
import Divider from "@mui/material/Divider";
import Stack2 from "@mui/material/Stack";
import { styled as styled5 } from "@mui/material/styles";
import { ExpandIcon } from "@availity/mui-icon";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var SelectDivider = styled5(Divider, {
  name: "MuiSelect",
  slot: "AvEndAdornmentDivider",
  overridesResolver: (props, styles) => styles.avEndAdornmentDivider
})({});
var SelectExpandIcon = styled5(ExpandIcon, {
  name: "MuiSelect",
  slot: "AvExpandIcon",
  overridesResolver: (props, styles) => styles.avExpandIcon
})({});
var InnerEndAdornment = (args) => /* @__PURE__ */ jsxs6(Stack2, __spreadProps(__spreadValues({}, args), { direction: "row", sx: { height: "100%", top: "unset!important" }, children: [
  /* @__PURE__ */ jsx11(SelectDivider, { orientation: "vertical", className: "MuiSelect-avEndAdornmentDivider" }),
  /* @__PURE__ */ jsx11(SelectExpandIcon, { className: "MuiSelect-avExpandIcon" })
] }));
var SelectPropOverrides = __spreadValues({ IconComponent: InnerEndAdornment }, InputPropOverrides);
var SelectAccessibilityOverrides = (openDetected, setOpenDetected, open) => {
  if (setOpenDetected && open === void 0) {
    const onOpen = () => {
      setOpenDetected(true);
    };
    const onClose = () => {
      setOpenDetected(false);
    };
    return openDetected ? { onOpen, onClose } : { onOpen, onClose, SelectDisplayProps: { "aria-controls": "" } };
  }
  return open ? {} : { SelectDisplayProps: { "aria-controls": "" } };
};
var Select = (props) => {
  const [openDetected, setOpenDetected] = useState(false);
  return /* @__PURE__ */ jsx11(
    MuiSelect,
    __spreadValues(__spreadValues(__spreadValues({}, props), SelectPropOverrides), SelectAccessibilityOverrides(openDetected, setOpenDetected, props == null ? void 0 : props.open))
  );
};

// src/lib/Switch.tsx
import { styled as styled6 } from "@mui/material";
import MuiSwitch from "@mui/material/Switch";
import { svgPathData, width, height } from "@fortawesome/free-solid-svg-icons/faCheck";
import { jsx as jsx12 } from "react/jsx-runtime";
var CheckedIconSwitch = styled6(MuiSwitch, { name: "AvSwitchCheckedIcon", slot: "root" })(({ theme }) => ({
  "& .Mui-checked": {
    "+ .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 12,
        height: 12,
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 ${width} ${height}"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="${svgPathData}"/></svg>')`
      }
    }
  }
}));
var Switch = (_a) => {
  var _b = _a, { showCheckedIcon } = _b, args = __objRest(_b, ["showCheckedIcon"]);
  if (showCheckedIcon && args.size === "small") {
    return /* @__PURE__ */ jsx12(CheckedIconSwitch, __spreadValues({}, args));
  }
  return /* @__PURE__ */ jsx12(MuiSwitch, __spreadValues({}, args));
};
export {
  FieldHelpIcon,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Input,
  InputAdornment,
  InputPropOverrides,
  Radio,
  RadioGroup,
  RequiredKey,
  SearchByContainer,
  SearchByFormGroup,
  Select,
  SelectAccessibilityOverrides,
  SelectDivider,
  SelectExpandIcon,
  SelectPropOverrides,
  Switch,
  triggerFieldHelp
};
